import { StyleSheet } from 'react-native';

const Styles = StyleSheet.create({
  appContainer: {
    backgroundColor: '#fff',
    alignItems: 'stretch',
    padding: '5%',
    flex: 1,
  },
  appBody: {
    flex: 8,
  },
  appFooter: {
    flex: 1,
  },
  footerLinkText: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: 25,
    color: '#E65100'
  },
  grammarTestContainer: {
    flexDirection: 'column',
    flex: 1,
    justifyContent: 'space-around',
  },
  grammarTestCasePromptContainer: {
    alignItems: 'center',
    justifyContent: 'space-around',
    flex: 1,
  },
  grammarTestCasePromptText: {
    fontWeight: 'bold',
    fontSize: 40,
    textAlign: 'center',
  },
  grammarTestCaseTranslationText: {
    fontSize: 20,
    textAlign: 'center',
  },
  grammarTestCaseContainer: {
    flex: 2,
    flexDirection: 'column',
    justifyContent: 'center',
  },
  grammarTestExplanationHeader: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  grammarExplanationSubHeaderText: {
    flex: 1,
    fontSize: 20,
  },
  grammarTestExplanationBody: {
    flex: 4,
    alignItems: 'center',
    justifyContent: 'center',
  },
  grammarTestAnswerExplanationText: {
    fontSize: 20,
    textAlign: 'center',
  },
  tableRow: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignSelf: 'stretch',
  },
  tableCell: {
    flex: 1,
    alignSelf: 'stretch',
  },
  tableHeading: {
    flex: 1,
    alignSelf: 'stretch',
    fontWeight: 'bold',
  },
  buttonText: {
    margin: 8,
    textAlign: 'center',
    fontSize: 40,
  },
  buttonSelected: {
    // teal 200 from https://material.io/design/color/the-color-system.html#tools-for-picking-colors
    backgroundColor: '#80CBC4',
    elevation: 4,
    borderRadius: 2
  },
  buttonUnselected: {
    // teal 50 from https://material.io/design/color/the-color-system.html#tools-for-picking-colors
    backgroundColor: '#E0F2F1',
    elevation: 4,
    borderRadius: 2
  }
});

export default Styles
